import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Button, PageSidebar } from "@inductiveautomation/ws-components";

import { getConfirmationStyles } from "./_confirmation.styles";

const PrimaryEmailConfirmation = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "profile.confirmation.primary_email",
  });
  const navigate = useNavigate();
  const { classes } = getConfirmationStyles();

  return (
    <PageSidebar
      testId="primary-email-confirmation"
      heading={t("heading")}
      supportingText={t("description")}
    >
      <div className={classes.helperContainer}>
        <span className={classes.helperText}>{t("helper_text")}</span>

        <Button
          id="go-to-account"
          testId="go-to-account"
          buttonVariant="text"
          size="small"
          label={t("helper_button_text")}
          onClick={() => void navigate("/")}
        />
      </div>
    </PageSidebar>
  );
};

export default PrimaryEmailConfirmation;
